export const scrollToError = () => {
    const element = window.document.getElementsByClassName('error')
    element[0]?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
